/* eslint-disable react-hooks/exhaustive-deps */
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { answerCountAtom } from "../jotai/common";

const useSelect = (ANSWER: number) => {
  const [select, setSelect] = useState(0);

  const [answerCount, setAnswerCount] = useAtom(answerCountAtom);

  const onClickItem = (value: number) => {
    if (!select) {
      Swal.fire({
        title: `${value} 번을 선택하시겠습니까?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: `네. ${value} 번이 확실합니다!`,
        cancelButtonText: "취소",
      }).then((result) => {
        if (result.isConfirmed) {
          setSelect(value);
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "두번의 기회는 없습니다.",
        confirmButtonText: `네..`,
      });
    }
  };

  useEffect(() => {
    if (select === ANSWER) {
      setAnswerCount((prev) => prev + 1);
    }
  }, [select]);

  return {
    select,
    onClickItem,
    answerCount,
  };
};

export default useSelect;
